import { useSelector } from 'react-redux';
import {
  getAvailableDomainEntities,
  getDomainItemsEntitiesByDomain,
} from 'js/reducers/domains/selectors';
import { getDomainEntitiesById } from 'js/reducers/entities/selectors';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { loadAllDomains } from 'js/actions';
import { useEffect } from 'react';

export function useMarketplaceDomains() {
  const dispatch = useAppDispatch();
  const availableDomainEntities = useSelector(getAvailableDomainEntities);
  const domainEntitiesById = useSelector(getDomainEntitiesById);
  const itemsByDomain = useSelector(getDomainItemsEntitiesByDomain);
  const custodiansByDomain = useSelector((state: any) => state.domains.custodiansByDomain);
  const itemDocById = useSelector((state: any) => state.domains.itemDocById);

  useEffect(() => {
    dispatch(loadAllDomains());
  }, []);

  return {
    availableDomainEntities,
    domainEntitiesById,
    itemsByDomain,
    custodiansByDomain,
    itemDocById,
  };
}
